import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css'
})
export class AlertComponent {
  @Input() visible = false;
  @Input() title = 'ALERT';
  @Input() message = 'This is an alert message.';
  @Input() alertbgcolor: string = '#007A8F';
  @Input() alerttextcolor: string = '#FFFFFF';
  @Output() closed = new EventEmitter<void>();

  closeAlert() {
    this.closed.emit();
  }
}
